import { useContext, useRef } from 'react';
import { createPortal } from 'react-dom';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useSelector } from '@s20/hooks/redux.hooks';
import { getTenant } from '@s20/selectors/features/common.selectors';
import { httpClient } from '@s20/services/httpClient';
import SlideForm from '../../../common/forms/SlideForm';
import Input from '../../../common/forms/Input';
import AddressInput from '../../../address/AddressInput';
import { ApiRoutes } from '../../../Common';
import { FormContext, toasty } from '../../../common/forms/FormElements';

export const CustomerForm = ({ show, setShowSlideForm }) => {
    const queryClient = useQueryClient();
    const ref = useRef(null);

    const tenant = useSelector(getTenant);
    const { setFieldValue } = useContext(FormContext);

    const mutation = useMutation({
        mutationFn: async (values) => {
            const response = await httpClient.post(ApiRoutes.company.createQuickCustomer(), values);

            return response.data;
        },
        onSuccess: (companyId) => {
            queryClient.invalidateQueries({ queryKey: ['customers'] });

            setFieldValue('companyId', companyId);
            setShowSlideForm(false);

            toasty.success('Customer organization added successfully');
        },
    });

    return createPortal(
        <SlideForm
            show={show}
            id="quickCustomerForm"
            formTitle="Add Customer Organization"
            onSubmit={mutation.mutateAsync}
            onClose={() => setShowSlideForm(false)}
            formRef={ref}
            initialValues={{
                companyName: '',
                countryId: tenant.countryId,
                countryCode: tenant.countryCode,
            }}
        >
            {({ values }) => (
                <>
                    <Input
                        label="Company Name"
                        id="companyName"
                        name="companyName"
                        placeholder="Enter Name (max 150 characters)"
                        maxLength="150"
                        pattern="[^()\/><\][\\\x22;|]+"
                        required
                        error="Name is required and can only contain the following special characters: hyphens and periods."
                    />

                    <AddressInput
                        address={values}
                        showCountryInput={false}
                        onStateChanged={(state) => {
                            setFieldValue('stateId', state.id);
                        }}
                        single
                    />
                </>
            )}
        </SlideForm>,
        document.body,
    );
};